module.exports = __webpack_public_path__ + "img/0-view.5cc0c814.png";